/**
 * 数値か判定してカンマ区切り、円を付与して返却する
 */
export const parsePrice = (num: unknown, symbol: unknown = '円') => {
  return /\d+/.test(num as string)
    ? `${parseInt(num as string, 10).toLocaleString()}${symbol}`
    : '';
};
